<template>
  <table class="asd-table">
    <thead>
      <tr class="table-heading">
        <th></th>
        <th>
          {{ $t('common.name') }}
        </th>
        <th>
          Aktivní do
        </th>
        <th>
          Obsahuje vlastnosti
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ProjectTypeRow v-for="projectType in projectTypes"
                      :key="projectType.id"
                      :projectTypeId="projectType.id"
      ></ProjectTypeRow>
    </tbody>
  </table>
</template>

<script>
import ProjectTypeRow from 'CORE/components/project/type/row'
import { czSorter } from 'CORE/utils/sorters'
import { get, chain } from 'lodash'

export default {
    name: 'ProjectTypeTable',
    components: {
        ProjectTypeRow,
    },
    props: {
        rootFilter: {
            type: Object,
            required: false,
            default: _ => {},
        },
    },
    computed: {
        projectTypes() {
            return chain(this.$store.getters.projectTypes)
                .sortWith((a, b) => czSorter('asc')(...[a, b].map(c => get(c, 'name'))))
                .orderBy(['validUntil'], ['desc'])
                .value()
        },
    },
}
</script>
